import { useEffect } from 'react';
import AppcuesService from '../services/AppcuesService';

const appcuesService = AppcuesService.getInstance();

function useAppcues() {
  // Initialize AppCues Service
  if (!appcuesService.isInitialized()) {
    appcuesService.initialize();
    console.info('%c ℹ️ APPCUES INITIALIZED', 'background: #006579; color: #c2f5ff; font-size: 12px');
  }

  useEffect(() => {
    if (appcuesService.isInitialized()) {
      // TODO: Check if this is necessary
      appcuesService.page();
      console.info('%c ℹ️ APPCUES PAGE', 'background: #006579; color: #c2f5ff; font-size: 12px');
    }
  }, []);

  return {
    appcuesService,
  };
}

export default useAppcues;
